import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { prepareEmbedIframeAuthBypass } from '@/embed/embedAuthBypass';
import {
  bootstrapEmbedHostContextFromUrl,
  subscribeEmbedHostContextFromPostMessage,
} from '@/services/embedHostContext';
import './index.css';

prepareEmbedIframeAuthBypass();
bootstrapEmbedHostContextFromUrl();
if (window.location.pathname.startsWith('/embed')) {
  document.documentElement.classList.add('bernoulli-embed-route');
  const unsubscribeEmbedPostMessage = subscribeEmbedHostContextFromPostMessage();
  window.addEventListener('pagehide', unsubscribeEmbedPostMessage, { once: true });
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);
